import classNames from "classnames";
import omit from "lodash.omit";
import PropTypes from "prop-types";
import React, { useEffect } from "react";
import {
    defineMessages,
    FormattedMessage,
    injectIntl,
    intlShape,
} from "react-intl";
import { Button, message } from "antd";
import { connect } from "react-redux";
import MediaQuery from "react-responsive";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import tabStyles from "react-tabs/style/react-tabs.css";
import VM from "scratch-vm";
import Renderer from "scratch-render";

import Blocks from "../../containers/blocks.jsx";
// CostumeTab 已移除 - 不需要造型功能
// import CostumeTab from "../../containers/costume-tab.jsx";
import TargetPane from "../../containers/target-pane.jsx";
// SoundTab 已移除 - 不需要声音功能
// import SoundTab from "../../containers/sound-tab.jsx";
import StageWrapper from "../../containers/stage-wrapper.jsx";
import Loader from "../loader/loader.jsx";
import Box from "../box/box.jsx";
import MenuBar from "../menu-bar/menu-bar.jsx";
// 服装库已移除 - 不需要上传角色、随机、选择角色等功能
// import CostumeLibrary from "../../containers/costume-library.jsx";
// 背景库已移除 - 不需要上传背景、随机、选择背景等功能
// import BackdropLibrary from "../../containers/backdrop-library.jsx";
import Watermark from "../../containers/watermark.jsx";

// Backpack 已移除 - 不需要背包功能
// import Backpack from "../../containers/backpack.jsx";
import WebGlModal from "../../containers/webgl-modal.jsx";
// Tips Library 已移除 - 不需要教程系统
// import TipsLibrary from "../../containers/tips-library.jsx";
// Cards 已移除 - 不需要卡片教程系统
// import Cards from "../../containers/cards.jsx";
import Alerts from "../../containers/alerts.jsx";
import DragLayer from "../../containers/drag-layer.jsx";
import ConnectionModal from "../../containers/connection-modal.jsx";
import TelemetryModal from "../telemetry-modal/telemetry-modal.jsx";
// Debug Modal 已移除 - 不需要调试功能
// import DebugModal from "../debug-modal/debug-modal.jsx";

import layout, { STAGE_SIZE_MODES } from "../../lib/layout-constants";
import { resolveStageSize } from "../../lib/screen-utils";
import { themeMap } from "../../lib/themes";

import styles from "./gui.css";
// 扩展图标已移除 - 不需要扩展按钮
// import addExtensionIcon from "./icon--extensions.svg";
import codeIcon from "./icon--code.svg";
// 造型图标已移除
// import costumesIcon from "./icon--costumes.svg";
// 声音图标已移除
// import soundsIcon from "./icon--sounds.svg";
import DebugModal from "../debug-modal/debug-modal.jsx";
import { EyeOutlined } from "@ant-design/icons";
import {
    buildBlockTree,
    convertNumericStringsToNumbers,
    flattenJsonByNext,
} from "../../utils/tools.js";
import { sendMessage } from "../../api/common.js";
import { scaMessage } from "../../utils/antd-static.js";
import AgentManage from "@/pages/AgentManage/index.jsx";

const messages = defineMessages({
    addExtension: {
        id: "gui.gui.addExtension",
        description: "Button to add an extension in the target pane",
        defaultMessage: "Add Extension",
    },
});

// Cache this value to only retrieve it once the first time.
// Assume that it doesn't change for a session.
let isRendererSupported = null;

const getConentCompoent = (pathName) => {
    if (pathName === "agentManage") {
        return <AgentManage />;
    }

    return null;
};

const GUIComponent = (props) => {
    // 移除已废弃功能的 props，防止传递到 DOM 元素
    const filteredProps = omit(props, [
        'dispatch',
        // 已移除的模态框可见性 props
        'backdropLibraryVisible',
        'costumeLibraryVisible', 
        'cardsVisible',
        'tipsLibraryVisible',
        'debugModalVisible',
        'costumesTabVisible',
        'soundsTabVisible',
        'backpackVisible',
        'backpackHost',
        // 已移除的事件处理器 props
        'onExtensionButtonClick',
        'onActivateCostumesTab',
        'onActivateSoundsTab',
        'onRequestCloseBackdropLibrary',
        'onRequestCloseCostumeLibrary',
        'onRequestCloseDebugModal'
    ]);

    const {
        accountNavOpen,
        activeTabIndex,
        alertsVisible,
        authorId,
        authorThumbnailUrl,
        authorUsername,
        basePath,
        blocksId,
        blocksTabVisible,
        canChangeLanguage,
        canChangeTheme,
        canCreateNew,
        canEditTitle,
        canManageFiles,
        canRemix,
        canSave,
        canCreateCopy,
        canShare,
        canUseCloud,
        children,
        connectionModalVisible,
        enableCommunity,
        intl,
        isCreating,
        isFullScreen,
        pathName,
        isPlayerOnly,
        isRtl,
        isShared,
        isTelemetryEnabled,
        isTotallyNormal,
        loading,
        locale,
        logo,
        renderLogin,
        onClickAbout,
        onClickAccountNav,
        onCloseAccountNav,
        onLogOut,
        onOpenRegistration,
        onToggleLoginOpen,
        onActivateTab,
        onClickLogo,
        onProjectTelemetryEvent,
        onRequestCloseTelemetryModal,
        onSeeCommunity,
        onShare,
        onShowPrivacyPolicy,
        onStartSelectingFileUpload,
        onTelemetryModalCancel,
        onTelemetryModalOptIn,
        onTelemetryModalOptOut,
        showComingSoon,
        stageSizeMode,
        targetIsStage,
        telemetryModalVisible,
        theme,
        vm,
        ...componentProps
    } = filteredProps;
    const [messageApi, contextHolder] = message.useMessage();

    // 根据语言动态设置页面标题
    useEffect(() => {
        const title = locale === 'zh-cn' 
            ? '元造工坊 - 图形化编程' 
            : 'Aura Labs - Graphics Programming';
        document.title = title;
    }, [locale]);
    if (children) {
        return <Box {...componentProps}>{children}</Box>;
    }

    const tabClassNames = {
        tabs: styles.tabs,
        tab: classNames(tabStyles.reactTabsTab, styles.tab),
        tabList: classNames(tabStyles.reactTabsTabList, styles.tabList),
        tabPanel: classNames(tabStyles.reactTabsTabPanel, styles.tabPanel),
        tabPanelSelected: classNames(
            tabStyles.reactTabsTabPanelSelected,
            styles.isSelected
        ),
        tabSelected: classNames(
            tabStyles.reactTabsTabSelected,
            styles.isSelected
        ),
    };

    if (isRendererSupported === null) {
        isRendererSupported = Renderer.isSupported();
    }

    const sendMessageTest = async () => {
        const target = vm.runtime.targets.find(
            (t) => t.id === vm.editingTarget.id
        );

        let blockTrees = [];

        if (target && target.blocks) {
            const allBlocks = Object.values(target.blocks._blocks);
            // allBlocks 就是当前场景（角色或舞台）的所有积木对象
            blockTrees = buildBlockTree(allBlocks);
            // console.log(JSON.stringify(blockTrees, null, 2));
        } else {
            console.warn("Target 或 blocks 未找到");
        }

        if (blockTrees.length === 0) {
            return message.warning(intl.formatMessage({
                id: "gui.gui.noBlocks",
                defaultMessage: "No blocks"
            }));
        }

        const flattenTree = flattenJsonByNext(blockTrees);
        const reqCommands = flattenTree.map((item) => {
            // console.log("item_1", item.inputs);
            // console.log("item_2", inputValues[0]);
            if (item.inputs) {
                // const inputValues = Object.values(item.inputs);
                return {
                    opcode: item.opcode,
                    arguments: item.inputs,
                    // arguments: {
                    //     steps: inputValues[0] || "",
                    // },
                };
            } else {
                message.warning(intl.formatMessage({
                    id: "gui.gui.blocksInDevelopment",
                    defaultMessage: "Other blocks are under development"
                }));
                return false;
            }
        });

        let curData = localStorage.getItem("selectedDeviceData");
        if (curData) {
            curData = JSON.parse(curData);
        } else {
            message.warning(intl.formatMessage({
                id: "gui.gui.pleaseSelectDevice",
                defaultMessage: "Please select a device first"
            }));
            return false;
        }

        const reqData = {
            session_id: curData.session_id,
            macAddress: curData.value,
            commands: convertNumericStringsToNumbers(reqCommands),
            deviceType: curData.deviceType,
        };

        try {
            const resp = await sendMessage(reqData);
            // const resp = reqData;

            if (resp.status === "success" || resp.code === 0) {
                message.success(intl.formatMessage({
                    id: "gui.gui.messageSentSuccess",
                    defaultMessage: "Message sent successfully"
                }));
            } else if (resp.msg) {
                message.error(resp.msg);
            } else {
                message.error(intl.formatMessage({
                    id: "gui.gui.messageSentFailed",
                    defaultMessage: "Failed to send message"
                }));
            }
        } catch (error) {
            message.error(intl.formatMessage({
                id: "gui.gui.messageSentFailed",
                defaultMessage: "Failed to send message"
            }));
        }
    };

    return (
        <MediaQuery minWidth={layout.fullSizeMinWidth}>
            {(isFullSize) => {
                const stageSize = resolveStageSize(stageSizeMode, isFullSize);

                return isPlayerOnly ? (
                    <StageWrapper
                        isFullScreen={isFullScreen}
                        isRendererSupported={isRendererSupported}
                        isRtl={isRtl}
                        loading={loading}
                        stageSize={STAGE_SIZE_MODES.large}
                        vm={vm}
                    >
                        {alertsVisible ? (
                            <Alerts className={styles.alertsContainer} />
                        ) : null}
                    </StageWrapper>
                ) : (
                    <Box
                        className={styles.pageWrapper}
                        dir={isRtl ? "rtl" : "ltr"}
                        {...componentProps}
                    >
                        {telemetryModalVisible ? (
                            <TelemetryModal
                                isRtl={isRtl}
                                isTelemetryEnabled={isTelemetryEnabled}
                                onCancel={onTelemetryModalCancel}
                                onOptIn={onTelemetryModalOptIn}
                                onOptOut={onTelemetryModalOptOut}
                                onRequestClose={onRequestCloseTelemetryModal}
                                onShowPrivacyPolicy={onShowPrivacyPolicy}
                            />
                        ) : null}
                        {loading ? <Loader /> : null}
                        {isCreating ? (
                            <Loader messageId="gui.loader.creating" />
                        ) : null}
                        {isRendererSupported ? null : (
                            <WebGlModal isRtl={isRtl} />
                        )}
                        {/* Tips Library 已移除 - 不需要教程系统 */}
                        {/* tipsLibraryVisible ? <TipsLibrary /> : null*/}
                        {/* Cards 已移除 - 不需要卡片教程系统 */}
                        {/* cardsVisible ? <Cards /> : null*/}
                        {alertsVisible ? (
                            <Alerts className={styles.alertsContainer} />
                        ) : null}
                        {connectionModalVisible ? (
                            <ConnectionModal vm={vm} />
                        ) : null}
                        {/* 服装库已移除 - 不需要上传角色、随机、选择角色等功能 */}
                        {/* costumeLibraryVisible ? (
                            <CostumeLibrary
                                vm={vm}
                                onRequestClose={onRequestCloseCostumeLibrary}
                            />
                        ) : null*/}
                        {/* Debug Modal 已移除 - 不需要调试功能 */}
                        {/* {
                            <DebugModal
                                isOpen={debugModalVisible}
                                onClose={onRequestCloseDebugModal}
                            />
                        } */}
                        {/* 背景库已移除 - 不需要上传背景、随机、选择背景等功能 */}
                        {/* backdropLibraryVisible ? (
                            <BackdropLibrary
                                vm={vm}
                                onRequestClose={onRequestCloseBackdropLibrary}
                            />
                        ) : null*/}
                        <MenuBar
                            accountNavOpen={accountNavOpen}
                            authorId={authorId}
                            authorThumbnailUrl={authorThumbnailUrl}
                            authorUsername={authorUsername}
                            canChangeLanguage={canChangeLanguage}
                            canChangeTheme={canChangeTheme}
                            canCreateCopy={canCreateCopy}
                            canCreateNew={canCreateNew}
                            canEditTitle={canEditTitle}
                            canManageFiles={canManageFiles}
                            canRemix={canRemix}
                            canSave={canSave}
                            canShare={canShare}
                            className={styles.menuBarPosition}
                            enableCommunity={enableCommunity}
                            isShared={isShared}
                            isTotallyNormal={isTotallyNormal}
                            logo={logo}
                            renderLogin={renderLogin}
                            showComingSoon={showComingSoon}
                            onClickAbout={onClickAbout}
                            onClickAccountNav={onClickAccountNav}
                            onClickLogo={onClickLogo}
                            onCloseAccountNav={onCloseAccountNav}
                            onLogOut={onLogOut}
                            onOpenRegistration={onOpenRegistration}
                            onProjectTelemetryEvent={onProjectTelemetryEvent}
                            onSeeCommunity={onSeeCommunity}
                            onShare={onShare}
                            onStartSelectingFileUpload={
                                onStartSelectingFileUpload
                            }
                            onToggleLoginOpen={onToggleLoginOpen}
                        />
                        <Box className={styles.bodyWrapper}>
                            {pathName ? (
                                getConentCompoent(pathName)
                            ) : (
                                <Box className={styles.flexWrapper}>
                                    <Box className={styles.editorWrapper}>
                                        <Tabs
                                            forceRenderTabPanel
                                            className={tabClassNames.tabs}
                                            selectedIndex={activeTabIndex}
                                            selectedTabClassName={
                                                tabClassNames.tabSelected
                                            }
                                            selectedTabPanelClassName={
                                                tabClassNames.tabPanelSelected
                                            }
                                            onSelect={onActivateTab}
                                        >
                                            <TabList
                                                className={
                                                    tabClassNames.tabList
                                                }
                                            >
                                                <Tab
                                                    className={
                                                        tabClassNames.tab
                                                    }
                                                >
                                                    <img
                                                        draggable={false}
                                                        src={codeIcon}
                                                    />
                                                    <FormattedMessage
                                                        defaultMessage="Code"
                                                        description="Button to get to the code panel"
                                                        id="gui.gui.codeTab"
                                                    />
                                                </Tab>
                                                {/* 造型 Tab 已移除 - 不需要造型功能 */}
                                                {/* <Tab
                                                    className={
                                                        tabClassNames.tab
                                                    }
                                                    onClick={
                                                        onActivateCostumesTab
                                                    }
                                                >
                                                    <img
                                                        draggable={false}
                                                        src={costumesIcon}
                                                    />
                                                    {targetIsStage ? (
                                                        <FormattedMessage
                                                            defaultMessage="Backdrops"
                                                            description="Button to get to the backdrops panel"
                                                            id="gui.gui.backdropsTab"
                                                        />
                                                    ) : (
                                                        <FormattedMessage
                                                            defaultMessage="Costumes"
                                                            description="Button to get to the costumes panel"
                                                            id="gui.gui.costumesTab"
                                                        />
                                                    )}
                                                </Tab> */}
                                                {/* 声音 Tab 已移除 - 不需要声音功能 */}
                                                {/* <Tab
                                                    className={
                                                        tabClassNames.tab
                                                    }
                                                    onClick={
                                                        onActivateSoundsTab
                                                    }
                                                >
                                                    <img
                                                        draggable={false}
                                                        src={soundsIcon}
                                                    />
                                                    <FormattedMessage
                                                        defaultMessage="Sounds"
                                                        description="Button to get to the sounds panel"
                                                        id="gui.gui.soundsTab"
                                                    />
                                                </Tab> */}
                                            </TabList>
                                            <TabPanel
                                                className={
                                                    tabClassNames.tabPanel
                                                }
                                            >
                                                <Box
                                                    style={{
                                                        position: "absolute",
                                                        top: "90px",
                                                        right: "20px",
                                                        zIndex: 100,
                                                    }}
                                                >
                                                    <Button
                                                        onClick={
                                                            sendMessageTest
                                                        }
                                                        style={{
                                                            width: "64px",
                                                            height: "74px",
                                                            backgroundColor:
                                                                "#FF8C1A",
                                                            color: "#fff",
                                                            borderRadius: "5px",
                                                            display: "flex",
                                                            flexDirection:
                                                                "column",
                                                            justifyContent:
                                                                "center",
                                                            alignItems:
                                                                "center",
                                                        }}
                                                    >
                                                        <EyeOutlined
                                                            style={{
                                                                fontSize:
                                                                    "20px",
                                                            }}
                                                        />
                                                        <span
                                                            style={{
                                                                marginTop:
                                                                    "-7px",
                                                                lineHeight:
                                                                    "20px",
                                                            }}
                                                        >
                                                            <FormattedMessage
                                                                id="gui.gui.runToHardware.line1"
                                                                defaultMessage="Run to"
                                                            />
                                                            <br />
                                                            <FormattedMessage
                                                                id="gui.gui.runToHardware.line2"
                                                                defaultMessage="Hardware"
                                                            />
                                                        </span>
                                                    </Button>
                                                </Box>
                                                <Box
                                                    className={
                                                        styles.blocksWrapper
                                                    }
                                                >
                                                    <Blocks
                                                        key={`${blocksId}/${theme}`}
                                                        canUseCloud={
                                                            canUseCloud
                                                        }
                                                        grow={1}
                                                        isVisible={
                                                            blocksTabVisible
                                                        }
                                                        options={{
                                                            media: `${basePath}static/${themeMap[theme].blocksMediaFolder}/`,
                                                        }}
                                                        stageSize={stageSize}
                                                        theme={theme}
                                                        vm={vm}
                                                    />
                                                </Box>
                                                {/* 扩展按钮已移除 - 不需要扩展功能 */}
                                                {/* <Box className={styles.extensionButtonContainer}>
                                                    <button
                                                        className={styles.extensionButton}
                                                        title={intl.formatMessage(
                                                            messages.addExtension
                                                        )}
                                                        onClick={
                                                            onExtensionButtonClick
                                                        }
                                                    >
                                                        <img
                                                            className={
                                                                styles.extensionButtonIcon
                                                            }
                                                            draggable={false}
                                                            src={
                                                                addExtensionIcon
                                                            }
                                                        />
                                                    </button>
                                                </Box> */}
                                                <Box
                                                    className={styles.watermark}
                                                >
                                                    <Watermark />
                                                </Box>
                                            </TabPanel>
                                            {/* 造型 TabPanel 已移除 */}
                                            {/* <TabPanel
                                                className={
                                                    tabClassNames.tabPanel
                                                }
                                            >
                                                {costumesTabVisible ? (
                                                    <CostumeTab vm={vm} />
                                                ) : null}
                                            </TabPanel> */}
                                            {/* 声音 TabPanel 已移除 */}
                                            {/* <TabPanel
                                                className={
                                                    tabClassNames.tabPanel
                                                }
                                            >
                                                {soundsTabVisible ? (
                                                    <SoundTab vm={vm} />
                                                ) : null}
                                            </TabPanel> */}
                                        </Tabs>
                                        {/* 背包已移除 - 不需要背包功能 */}
                                        {/* {backpackVisible ? (
                                            <Backpack host={backpackHost} />
                                        ) : null} */}
                                    </Box>

                                    <Box
                                        className={classNames(
                                            styles.stageAndTargetWrapper,
                                            styles[stageSize]
                                        )}
                                    >
                                        <StageWrapper
                                            isFullScreen={isFullScreen}
                                            isRendererSupported={
                                                isRendererSupported
                                            }
                                            isRtl={isRtl}
                                            stageSize={stageSize}
                                            vm={vm}
                                        />
                                        <Box className={styles.targetWrapper}>
                                            <TargetPane
                                                stageSize={stageSize}
                                                vm={vm}
                                            />
                                        </Box>
                                    </Box>
                                </Box>
                            )}
                        </Box>
                        <DragLayer />
                    </Box>
                );
            }}
        </MediaQuery>
    );
};

GUIComponent.propTypes = {
    accountNavOpen: PropTypes.bool,
    activeTabIndex: PropTypes.number,
    authorId: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]), // can be false
    authorThumbnailUrl: PropTypes.string,
    authorUsername: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]), // can be false
    backdropLibraryVisible: PropTypes.bool,
    // backpackHost 和 backpackVisible 已移除
    // backpackHost: PropTypes.string,
    // backpackVisible: PropTypes.bool,
    basePath: PropTypes.string,
    blocksTabVisible: PropTypes.bool,
    blocksId: PropTypes.string,
    canChangeLanguage: PropTypes.bool,
    canChangeTheme: PropTypes.bool,
    canCreateCopy: PropTypes.bool,
    canCreateNew: PropTypes.bool,
    canEditTitle: PropTypes.bool,
    canManageFiles: PropTypes.bool,
    canRemix: PropTypes.bool,
    canSave: PropTypes.bool,
    canShare: PropTypes.bool,
    canUseCloud: PropTypes.bool,
    // cardsVisible 已移除
    // cardsVisible: PropTypes.bool,
    children: PropTypes.node,
    // costumeLibraryVisible 已移除
    // costumeLibraryVisible: PropTypes.bool,
    // costumesTabVisible 和 soundsTabVisible 已移除
    // costumesTabVisible: PropTypes.bool,
    // soundsTabVisible: PropTypes.bool,
    // debugModalVisible 已移除
    // debugModalVisible: PropTypes.bool,
    enableCommunity: PropTypes.bool,
    intl: intlShape.isRequired,
    isCreating: PropTypes.bool,
    isFullScreen: PropTypes.bool,
    pathName: PropTypes.string,
    isPlayerOnly: PropTypes.bool,
    isRtl: PropTypes.bool,
    isShared: PropTypes.bool,
    isTotallyNormal: PropTypes.bool,
    loading: PropTypes.bool,
    locale: PropTypes.string,
    logo: PropTypes.string,
    // onActivateCostumesTab 和 onActivateSoundsTab 已移除
    // onActivateCostumesTab: PropTypes.func,
    // onActivateSoundsTab: PropTypes.func,
    onActivateTab: PropTypes.func,
    onClickAccountNav: PropTypes.func,
    onClickLogo: PropTypes.func,
    // onExtensionButtonClick 已移除
    // onExtensionButtonClick: PropTypes.func,
    onCloseAccountNav: PropTypes.func,
    // onExtensionButtonClick 已移除
    // onExtensionButtonClick: PropTypes.func,
    onLogOut: PropTypes.func,
    onOpenRegistration: PropTypes.func,
    // onRequestCloseBackdropLibrary 和 onRequestCloseCostumeLibrary 已移除
    // onRequestCloseBackdropLibrary: PropTypes.func,
    // onRequestCloseCostumeLibrary: PropTypes.func,
    // onRequestCloseDebugModal 已移除
    // onRequestCloseDebugModal: PropTypes.func,
    onRequestCloseTelemetryModal: PropTypes.func,
    onSeeCommunity: PropTypes.func,
    onShare: PropTypes.func,
    onShowPrivacyPolicy: PropTypes.func,
    onStartSelectingFileUpload: PropTypes.func,
    onTabSelect: PropTypes.func,
    onTelemetryModalCancel: PropTypes.func,
    onTelemetryModalOptIn: PropTypes.func,
    onTelemetryModalOptOut: PropTypes.func,
    onToggleLoginOpen: PropTypes.func,
    renderLogin: PropTypes.func,
    showComingSoon: PropTypes.bool,
    // soundsTabVisible 已移除
    // soundsTabVisible: PropTypes.bool,
    stageSizeMode: PropTypes.oneOf(Object.keys(STAGE_SIZE_MODES)),
    targetIsStage: PropTypes.bool,
    telemetryModalVisible: PropTypes.bool,
    theme: PropTypes.string,
    // tipsLibraryVisible 已移除
    // tipsLibraryVisible: PropTypes.bool,
    vm: PropTypes.instanceOf(VM).isRequired,
};
GUIComponent.defaultProps = {
    // backpackHost 和 backpackVisible 已移除
    // backpackHost: null,
    // backpackVisible: false,
    basePath: "./",
    blocksId: "original",
    canChangeLanguage: true,
    canChangeTheme: true,
    canCreateNew: false,
    canEditTitle: false,
    canManageFiles: true,
    canRemix: false,
    canSave: false,
    canCreateCopy: false,
    canShare: false,
    canUseCloud: false,
    enableCommunity: false,
    isCreating: false,
    isShared: false,
    isTotallyNormal: false,
    loading: false,
    showComingSoon: false,
    stageSizeMode: STAGE_SIZE_MODES.large,
};

const mapStateToProps = (state) => ({
    // This is the button's mode, as opposed to the actual current state
    blocksId: state.scratchGui.timeTravel.year.toString(),
    stageSizeMode: state.scratchGui.stageSize.stageSize,
    theme: state.scratchGui.theme.theme,
});

export default injectIntl(connect(mapStateToProps)(GUIComponent));
